import { SET_LEAD_SOURCE, SET_SNACK, SET_SNACK_INFO, SET_SALES_DATA, SET_USERS_DATA, SET_SALES_STAGE_LEAD, CLEAR_SALES_DATA, LOGOUT, SET_SALESL2M_DATA, CLEAR_L2M_DATA, SET_DESIGN_STAGE_LEAD, SET_MEETING_TRACKER,  SET_STAGE_REVIEW, PROJECT_NO, MONTHLY_CONVERSION_GOAL, LEADS_GENERATED_DASHBOARD, LEAD_SOURCE_TYPE_BOOKING_REPORT, LEADS_SOURCE_TRACKER, LEADS_LIFECYCLE_DASHBOARD, CHANNEL_PARTNER_DASHBOARD, IDSO_DASHBOARD, DSO_DASHBOARD, SOD_DASHBOARD, SOC_DASHBOARD, PPS_DASHBOARD, UES_DASHBOARD } from "./types";
import HttpService from "../../services/httpService";

export const getSourceOfLeadData = () => async (dispatch) => {
  try {
    const response = await HttpService.getLeadMaster(); // Fetch lead data
    dispatch({ type: SET_LEAD_SOURCE, payload: response.data });
  } catch (error) {
    console.error(error);
    dispatch({ type: SET_SNACK, payload: true });
    dispatch({
      type: SET_SNACK_INFO,
      payload: { msg: error.response?.data || "Error fetching lead source", snackSeverity: "error" },
    });
  }
};

export const setLatestScan = (data) =>{
  return {
    type : PROJECT_NO,
    payload : data
  }
}

//Set getLeadToMeetingOrderData
export const leadToMeetingOrderData = (data) => {
  return {
    type: SET_SALESL2M_DATA,
    payload: data
  };
};

// Action creator for setting sales data
export const setSalesData = (data) => {
  return {
    type: SET_SALES_DATA,
    payload: data
  };
};

// Action creator for setting users data
export const setUsersDataInRedux = (data) => {
  return {
    type: SET_USERS_DATA,
    payload: data
  };
};


// ✅ New action creator for setting sales stage lead
export const setSalesStageLead = (data) => {
  return {
    type: SET_SALES_STAGE_LEAD,
    payload: data
  };
};

// ✅ New action creator for setting sales stage review lead
export const setStageReview = (data) => {
  return {
    type: SET_STAGE_REVIEW,
    payload: data
  };
};

// ✅ New action creator for setting design  stage summary
export const setOverAllDesignSummary = (data) => {
  return {
    type: SET_DESIGN_STAGE_LEAD,
    payload: data
  };
};

// ✅ New action creator for setting sales meeting info
export const setMeetingTrack = (data) => {
  return {
    type: SET_MEETING_TRACKER,
    payload: data
  };
};



export const clearSalesStageLead = () => {
  return {
      type: CLEAR_SALES_DATA
  };
};

export const clearL2Mdata = () => {
  return {
      type: CLEAR_L2M_DATA
  };
};


// ✅ New action creator for logout
export const logoutUser = () => {
  return {
    type: LOGOUT
  };
};

// ✅ Monthly Conversion Goal
export const setMonthlyConversionGoal = (data) => {
  return {
    type: MONTHLY_CONVERSION_GOAL,
    payload: data
  };
};

// Leads Generated Dashboard
export const setLGDData = (data) => {
  return {
    type: LEADS_GENERATED_DASHBOARD,
    payload: data
  };
};

// Leads Source Type Booking Report
export const setLSTBRData = (data) => {
  return {
    type: LEAD_SOURCE_TYPE_BOOKING_REPORT,
    payload: data
  };
};

// Lead Source Tracker
export const setLSTData = (data) => {
  return {
    type: LEADS_SOURCE_TRACKER,
    payload: data
  };
};

// Leads LifeCycle Dashboard
export const setLLDData = (data) => {
  return {
    type: LEADS_LIFECYCLE_DASHBOARD,
    payload: data
  };
};

// Channel Partner Dashboard
export const setCPDData = (data) => {
  return {
    type: CHANNEL_PARTNER_DASHBOARD,
    payload: data
  };
};

// IDSO Dashboard
export const setIDSOData = (data) => {
  return {
    type: IDSO_DASHBOARD,
    payload: data
  };
};

// DSO-Review Dashboard
export const setDSOData = (data) => {
  return {
    type: DSO_DASHBOARD,
    payload: data
  };
};

// Stage Value SOD Dashboard
export const setSODData = (data) => {
  return {
    type: SOD_DASHBOARD,
    payload: data
  };
};

// Stage Value SOC Dashboard
export const setSOCData = (data) => {
  return {
    type: SOC_DASHBOARD,
    payload: data
  };
};

// Stage Value PPS Dashboard
export const setPPSData = (data) => {
  return {
    type: PPS_DASHBOARD,
    payload: data
  };
};

// Stage Value UES Dashboard
export const setUESData = (data) => {
  return {
    type: UES_DASHBOARD,
    payload: data
  };
};